import { Repository } from '../abstraction';
import { StorageResourceLocation } from '../../data/specialized/storage/storage.location';
import { ReadonlyStorageRepository } from './readonly-storage.repository';
import { StorageDataAccess } from '../../data-access/abstraction/storage.data-access';

export class StorageRepository<T, TParams> extends ReadonlyStorageRepository<T | null, TParams> implements Repository<T | null, T | null, TParams, TParams> {

  constructor(dataAccess: StorageDataAccess,
              key: string) {
    super(dataAccess, key);
  }

  async create(value: T, params: TParams): Promise<T> {
    const location: StorageResourceLocation = {
      key: this.getKey(params)
    };
    return this.dataAccess.set(location, value);
  }
  async update(value: T, params: TParams): Promise<T> {
    const location: StorageResourceLocation = {
      key: this.getKey(params)
    };
    return this.dataAccess.set(location, value);
  }
  async patch(patch: Partial<T>, params: TParams): Promise<T> {
    const location: StorageResourceLocation = {
      key: this.getKey(params)
    };
    return this.dataAccess.patch(location, patch);
  }
  async delete(params: TParams): Promise<T> {
    const location: StorageResourceLocation = {
      key: this.getKey(params)
    };
    return this.dataAccess.delete(location);
  }

}
